export default {
  ZH_HK: {
    mixing: "混合題",
    single: "單選題",
    multiple: "多選題",
    judgment: "判斷題",
    segmentation: "閱讀題",
    fill: "填充題",
    whole: "閱讀題",
    short: "短答題",
    choice: "選擇題",
    quantity: "數量",
    writing: "寫作",
    writingType: "寫作類",
    fillType: "填充類",
    enTemplate: "英文模板",
    ProfessionalTemplate: "專業模板",
    defaultTemplate: "普通模板",
    zhTemplate: "中文-拼音模板",
    gsTemplate: "中文-古詩模板",
    writingList: "寫作類型",
    content: "內容數量",
    words: "生詞數量",
    sentences: "重點句型數量",
    previewMode: "預覽模式",
    close: "退出預覽模式",
    topic: "題目",
    celebrity1: "愛因斯坦",
    celebrity2: "牛頓",
    celebrity4: "愛迪生",
    celebrity3: "李白"
  },
  zh_cn: {
    mixing: "混合题",
    single: "单选题",
    multiple: "多选题",
    judgment: "判断题",
    segmentation: "分段阅读",
    fill: "填空题",
    whole: "阅读",
    short: "简答题",
    choice: "选择题",
    quantity: "数量",
    writing: "写作",
    writingType: "写作类",
    fillType: "填充类",
    enTemplate: "英文模板",
    ProfessionalTemplate: "专业模板",
    defaultTemplate: "普通模板",
    zhTemplate: "中文-拼音模板",
    gsTemplate: "中文-古诗模板",
    writingList: "写作类型",
    content: "内容数量",
    words: "生词数量",
    sentences: "重点句型数量",
    previewMode: "预览模式",
    close: "退出预览模式",
    topic: "题目",
    celebrity1: "爱因斯坦",
    celebrity2: "牛顿",
    celebrity4: "爱迪生",
    celebrity3: "李白"
  },
  EN: {
    mixing: "Mixing",
    single: "Single-choice",
    multiple: "Multiple-select",
    judgment: "True or False",
    segmentation: "Article snippet",
    fill: "Fill-in-the-blanks",
    whole: "The entire article",
    short: "Short-answer",
    choice: "Multiple-choice",
    quantity: "Quantity",
    writing: "Writing",
    writingType: "Writing",
    fillType: "Fill",
    enTemplate: "English template",
    ProfessionalTemplate: "Professional template",
    defaultTemplate: "Default template",
    zhTemplate: "pinyin template",
    gsTemplate: "Ancient poetry template",
    writingList: "Writing type",
    content: "No. of Paragraphs",
    words: "No. of Words",
    sentences: "No. of Sentences",
    previewMode: "Preview Mode",
    close: "Exit preview mode",
    topic: "Question",
    celebrity1: "Albert Einstein",
    celebrity2: "Isaac Newton",
    celebrity4: "Thomas Edison",
    celebrity3: "Li Bai"
  },
  es: {
    mixing: "Mezcla",
    single: "Respuesta Única",
    multiple: "Respuesta Múltiple",
    judgment: "Verdadero o Falso",
    segmentation: "Preguntas de lectura",
    fill: "Llenar los espacios en blanco",
    whole: "Lectura (completa)",
    short: "Respuesta corta",
    choice: "Preguntas de opción múltiple",
    quantity: "Cantidad",
    writing: "Escritura",
    writingType: "Tipo de artículo",
    fillType: "Llenar los espacios en blanco",
    enTemplate: "Plantilla en inglés",
    ProfessionalTemplate: "Plantilla profesional",
    defaultTemplate: "Plantilla predeterminada",
    zhTemplate: "Plantilla de Pinyin en chino",
    gsTemplate: "Plantilla de poesía china",
    writingList: "Tipo de escritura",
    content: "Número de contenidos",
    words: "Número de palabras",
    sentences: "Número de oraciones",
    previewMode: "Modo de vista previa",
    close: "Salir del modo de vista previa",
    topic: "Pregunta",
    celebrity1: "Albert Einstein",
    celebrity2: "Isaac Newton",
    celebrity4: "Thomas Edison",
    celebrity3: "Li Bai"
  }
};
